import { z } from "zod"

export const AccountManagerSchema = z.object({
  name: z.string(),
  title: z.string().nullish(),
  userId: z.string(),
})

export const AccountManagerListSchema = z.array(AccountManagerSchema)
